import { render, staticRenderFns } from "./OZViewer.vue?vue&type=template&id=49ba3656&scoped=true&"
import script from "./OZViewer.vue?vue&type=script&lang=js&"
export * from "./OZViewer.vue?vue&type=script&lang=js&"
import style0 from "./OZViewer.vue?vue&type=style&index=0&id=49ba3656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ba3656",
  null
  
)

export default component.exports